import { Component, Input, ViewEncapsulation } from '@angular/core';

export interface Step {
  label: string;
  value: string;
}

@Component({
  selector: 'lib-stepper',
  standalone: true,
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class StepperComponent {
  @Input() steps: Step[] = [];
  @Input() activeStep?: string;

  isActive(step: Step): boolean {
    return step.value === this.activeStep;
  }

  isCompleted(step: Step): boolean {
    const activeIndex = this.steps.findIndex(s => s.value === this.activeStep);
    const stepIndex = this.steps.findIndex(s => s.value === step.value);
    return stepIndex < activeIndex;
  }
}
